exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.green[data-v-29d4ae88] {\n    color: green;\n}\n.red[data-v-29d4ae88] {\n    color: red;\n}\n", ""]);

// exports
